<template>
  <div class="body-wrapper">
    <a href="https://wa.me/6594363876" target="_blank" class="btn-wa">
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="48" height="48"><path fill="none" d="M0 0h24v24H0z"/><path d="M2.004 22l1.352-4.968A9.954 9.954 0 0 1 2 12C2 6.477 6.477 2 12 2s10 4.477 10 10-4.477 10-10 10a9.954 9.954 0 0 1-5.03-1.355L2.004 22zM8.391 7.308a.961.961 0 0 0-.371.1 1.293 1.293 0 0 0-.294.228c-.12.113-.188.211-.261.306A2.729 2.729 0 0 0 6.9 9.62c.002.49.13.967.33 1.413.409.902 1.082 1.857 1.971 2.742.214.213.423.427.648.626a9.448 9.448 0 0 0 3.84 2.046l.569.087c.185.01.37-.004.556-.013a1.99 1.99 0 0 0 .833-.231c.166-.088.244-.132.383-.22 0 0 .043-.028.125-.09.135-.1.218-.171.33-.288.083-.086.155-.187.21-.302.078-.163.156-.474.188-.733.024-.198.017-.306.014-.373-.004-.107-.093-.218-.19-.265l-.582-.261s-.87-.379-1.401-.621a.498.498 0 0 0-.177-.041.482.482 0 0 0-.378.127v-.002c-.005 0-.072.057-.795.933a.35.35 0 0 1-.368.13 1.416 1.416 0 0 1-.191-.066c-.124-.052-.167-.072-.252-.109l-.005-.002a6.01 6.01 0 0 1-1.57-1c-.126-.11-.243-.23-.363-.346a6.296 6.296 0 0 1-1.02-1.268l-.059-.095a.923.923 0 0 1-.102-.205c-.038-.147.061-.265.061-.265s.243-.266.356-.41a4.38 4.38 0 0 0 .263-.373c.118-.19.155-.385.093-.536-.28-.684-.57-1.365-.868-2.041-.059-.134-.234-.23-.393-.249-.054-.006-.108-.012-.162-.016a3.385 3.385 0 0 0-.403.004z" fill="rgba(35,205,100,1)"/></svg>
    </a>
    <div class="w-full header-banner">
      <div class="w-full header-bg">
        <div class="w-full header-top">
          <div class="container px-4 pt-6">
            <div class="w-full flex pt-4 pb-4">
              <div class="w-3/6 md:w-4/12 lg:w-4/12">
                <router-link class="m-auto" to="/"><img class="m-auto md:m-0" src="/images/logo.png"></router-link>
              </div>              
              <div class="w-5/6 md:w-6/10 lg:w-7/12 text-left flex items-center justify-end">                
                <div class="pr-0 block md:block">
                  <img class="w-5/6 hidden lg:block" src="/images/tel-icon.png">
                  <img class="w-5/6 block lg:hidden" src="/images/tel-icon.png">
                </div>
                <div class="block">
                  <div class="font-bold lg:text-2xl text-gray-800">Call us at<br><a href="tel:+6567471910">(+65) 6747 1910</a></div>                  
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="container px-4 pb-4 pt-0 lg:pt-2">
          <div class="w-full lg:flex section">
            <div class="w-full lg:w-7/12 text-center md:text-center lg:text-left">
              <div class="text-5xl md:text-5xl lg:text-6xl xl:text-6xl lg:text-blue font-bold title-text">
                   The Veteran
              </div>
              <div class="text-2xl lg:text-4xl text-green-700 lg:text-green-600 font-bold leading-10 mb-8 md:mb-16">
                <div class="pb-0 lg:pb-12 text-4xl lg:text-5xl xl:text-6xl">
                   in E-Waste <br class="block"><div class="pt-2 lg:pt-4 xl:pt-8">Disposal &amp;</div><div class="pt-2 lg:pt-4 xl:pt-8">Recycling</div>
                </div>
                 <div class="text-xl text-gray-800 font-semibold text-shadow-xl mt-10 lg:text-3xl lg:text-white lg:mt-20">
                   Computers, Laptops,<br class="block">Hard drives, Monitors,<br class="block">Printers, etc
                 </div>
              </div>              
              <div class="w-full hidden pt-2 md:pt-2 lg:block">
                <img src="/images/header-icon.png" class="md:pt-2">
              </div>
              <div class="w-full block lg:hidden">
                <img class="m-auto" src="/images/header-img-m.png">
              </div>
            </div>
            <div class="w-1/12 hidden lg:block"></div>
            <div id="contact-area" class="w-full md:w-9/12 lg:w-4/12 m-0 md:m-auto">
              <div class="w-full ">
                  <div class="w-full bg-white p-8">                  
                  <div class="w-full text-center text-3xl text-gray-800 font-bold leading-none mb-6 mt-5">
                    <span class="text-2xl lg:text-3xl">Request a</span><br/><span class="text-4xl lg:text-5xl font-extrabold">Free Quote</span>
                  </div> 
                  <!-- feedback.activamedia.com.sg script begins here -->
                  <iframe allowTransparency="true" style="min-height:620px; height:inherit; overflow:auto;" width="100%" id="contactform123" name="contactform123" marginwidth="0" marginheight="0" frameborder="0" src="https://feedback.activamedia.com.sg/my-contact-form-5979529.html">
                    <p>Your browser does not support iframes. The contact form cannot be displayed. Please use another contact method (phone, fax etc)</p>
                  </iframe> 
                  <!-- feedback.activamedia.com.sg script ends here -->
                  </div> 
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="w-full text-center md:flex mt-12">
      <div class="container px-4 pt-6 mx-auto flex flex-row items-center justify-between">
        <div class="w-1/5 lg:w-1/4 md:block title-line"></div>
        <div class="w-1/1 text-4xl md:text-5xl text-blue-400 font-bold leading-none title-text">
          Our Key Solutions
        </div>
        <div class="w-1/5 lg:w-1/4 md:block title-line"></div>
      </div>
    </div>
    <div class="w-full pt-10 md:pt-0 lg:pt-12">
      <div class="container px-4 pt-6 mx-auto flex flex-col lg:flex-row">       
        <div class="w-full mb-10 lg:mb-0">
          <div class="pl-0 pr-0 lg:pl-0 lg:pr-8" id="hdb">
            <div class="block text-2xl text-center text-white font-bold bg-blue-400 pt-2 pb-1 h-auto title-bg-color">
              ELECTRONIC DISPOSAL
            </div>            
            <div class="block bg-gray-300 pt-3 h-auto pb-3 lg:pb-10">
              <ul>
                <li class="pb-2">Collection of e-waste at your location</li>
                <li class="pb-2">Safe and Secure disposal service</li>
                <li class="pb-2">Certification provided for erasure/degauss of assets, if required</li>
                <li class="pb-2">Dispose accordingly to NEA standards and guidelines</li>      
              </ul>
            </div>
          </div>
        </div>
        <div class="w-full mb-10 lg:mb-0">
          <div class="pl-0 pr-0 lg:pl-0 lg:pr-4" id="condominium">
            <div class="block text-2xl text-center text-white font-bold bg-blue-400 pt-2 pb-1 h-auto title-bg-color">
              E-WASTE RECYCLING
            </div>            
            <div class="block bg-gray-300 pt-3 h-auto pb-3">
              <ul>
                <li class="pt-2 pb-2"><strong>Trade-in of computers and laptops<br>available</strong></li>
                <li class="pb-2">Brand protection, and full data wipe</li>
                <li class="pb-2">Collection of e-waste at your location</li>
                <li class="pb-6">Recycle in accordance to NEA standards &amp; guidelines</li>                
              </ul>
            </div>
          </div>
        </div>
        <div class="w-full mb-10 lg:mb-0">
          <div class="pl-0 pr-0 lg:pl-4 lg:pr-4" id="landed-interior">
            <div class="block text-2xl text-center text-white font-bold bg-blue-400 pt-2 pb-1 h-auto title-bg-color">
              LAPTOP/NOTEBOOK RENTAL
            </div>            
            <div class="block bg-gray-300 pt-3 h-auto pb-3 lg:pb-10">
              <ul>
                <li class="pt-2 pb-2">Good condition equipments</li>
                <li class="pb-2">Large scale capabilities</li>
                <li class="pb-2">Fast deployment</li>
                <li class="pb-3 lg:pb-12">Full set up provided</li>                 
              </ul>
            </div>
          </div>
        </div>        
      </div>
    </div>    
    <div class="w-full mt-8 lg:mt-12">
      <div class="w-full">        
        <div class="w-full lg:flex lg:pt-6 mb-12">
          <div class="w-full bg-cover lg:w-6/12">
            <img src="/images/promotion-bg.jpg" class="h-full" width="100%" height="100%">
          </div>
          <div class="w-full lg:w-6/12 lg:pl-12 title-bg-color">
            <div class="px-4 text-4xl md:text-5xl text-white font-bold leading-none pt-16 mb-3">
              What We Can Help You Dispose and Recycle
            </div>
            <div class="px-4 text-lg text-white leading-snug pt-6 mb-10">
              At Atrex Services, we offer different types of disposal services. We take our disposal process very seriously as we understand how certain information and data can be sensitive.
            </div>            
            <div class="mb-4 p-4 text-white">
              <table cellpadding="0" cellspacing="0" class="text-base md:text-lg text-white leading-snug w-full">
              <tr>
                <td valign="top" width="25px"><img class="xl:ml-auto" src="/images/icon-check.png"></td>
                <td class="pb-5 pl-3">Desktop computers</td>
              </tr>
              <tr>
                <td valign="top"><img class="xl:ml-auto" src="/images/icon-check.png"></td>
                <td class="pb-5 pl-3">Laptops</td>
              </tr>
              <tr>
                <td valign="top"><img class="xl:ml-auto" src="/images/icon-check.png"></td>
                <td class="pb-5 pl-3">Printers</td>
              </tr>
              <tr>
                <td valign="top"><img class="xl:ml-auto" src="/images/icon-check.png"></td>
                <td class="pb-5 pl-3">Monitors</td>
              </tr>
              <tr>
                <td valign="top"><img class="xl:ml-auto" src="/images/icon-check.png"></td>
                <td class="pb-5 pl-3">Hard disks</td>
              </tr>
              <tr>
                <td valign="top"><img class="xl:ml-auto" src="/images/icon-check.png"></td>
                <td class="pb-5 pl-3">Circuit boards</td>
              </tr>
              <tr>
                <td valign="top"><img class="xl:ml-auto" src="/images/icon-check.png"></td>
                <td class="pb-5 pl-3">Computer peripherals</td>
              </tr>
              <tr>
                <td valign="top"><img class="xl:ml-auto" src="/images/icon-check.png"></td>
                <td class="pb-5 pl-3">Cameras</td>
              </tr>
              <tr>
                <td valign="top"><img class="xl:ml-auto" src="/images/icon-check.png"></td>
                <td class="pb-5 pl-3">Mobile devices</td>
              </tr>
              <tr>
                <td valign="top"><img class="xl:ml-auto" src="/images/icon-check.png"></td>
                <td class="pb-5 pl-3">Servers</td>
              </tr>
              <tr>
                <td valign="top"><img class="xl:ml-auto" src="/images/icon-check.png"></td>
                <td class="pb-5 pl-3">Switches</td>
              </tr>
              <tr>
                <td valign="top"><img class="xl:ml-auto" src="/images/icon-check.png"></td>
                <td class="pb-5 pl-3">And other general electronics</td>
              </tr>
            </table>            
            </div>
          </div>
        </div>        
      </div>
    </div>
    <!-- ///////////////////////////////////////// OUR 4 icons START ///////////////////////////////////////// -->
    <div class="w-full text-center md:flex mt-12">
      <div class="container px-4 pt-6 mx-auto flex flex-row items-center justify-between">
        <div class="w-1/5 lg:w-1/3 md:block title-line"></div>
        <div class="w-1/1 text-4xl md:text-5xl text-blue-400 font-bold leading-none title-text">
          Our Commitments &amp; Assurance!
        </div>
        <div class="w-1/5 lg:w-1/3 md:block title-line"></div>
      </div>
    </div>
    <div class="w-full section">
      <div class="container px-4 pt-4 pb-2 lg:pt-0 flex flex-wrap mx-auto items-center justify-between">
        <div class="w-1/2 lg:w-1/4 pr-2 border-r-0 sm:border-r-0 lg:border-r-2 mt-6 border-black">
          <img src="images/icon-03.png" class="w-1/2 h-1/1 mx-auto" />
          <div class="font-bold text-center mt-4 text-xl lg:text-2xl">Compliance Certified<br/>ISO 9001:2015<br/>ISO 14001:2015<br/>ISO 45001:2018</div>
        </div>
        <div class="w-1/2 lg:w-1/4 pr-2 border-r-0 sm:border-r-0 lg:border-r-2 mt-6 border-black">
          <img src="images/icon-02.png" class="w-1/2 h-1/1 mx-auto" />
          <div class="font-bold text-center mt-4 text-xl lg:text-2xl">Safe &amp;<br/>Secure Disposal<br/><br/><br/></div>
        </div>
        <div class="w-1/2 lg:w-1/4 pr-2 pb-8 lg:pb-0 border-r-0 sm:border-r-0 lg:border-r-2 mt-6 border-black">
          <img src="images/icon-01.png" class="w-1/2 h-1/1 mx-auto" />
          <div class="font-bold text-center mt-4 text-xl lg:text-2xl">Accordance to<br/>NEA standard<br/><br/><br/></div>
        </div>
        <div class="w-1/2 lg:w-1/4 pl-2 pb-8 lg:pb-0 mx-auto">
          <img src="images/icon-04.png" class="w-1/2 h-1/1 mt-6 mx-auto" />
          <div class="font-bold text-center mt-4 text-xl lg:text-2xl">Experience &amp;<br/>Professional<br/><br/><br/></div>
        </div>
      </div>
    </div>
    <!-- ///////////////////////////////////////// OUR 4 icons END ///////////////////////////////////////// -->
    <!-- ///////////////////////////////////////// Ph section START ///////////////////////////////////////// -->
    <div class="max-w-none bg-cover bg-middle bg-center bg-no-repeat bg-img-01 py-8">     
      <div class="container px-4 mx-auto py-12 lg:content-center flex flex-wrap">
        <div class="w-full rounded-full py-2 lg:py-4 px-6 border-4 border-blue-200 bg-blue-800">        
            <div class="text-1xl text-center lg:text-3xl text-white font-bold">
              CALL US AT <a href="tel:+6567471910"><span class="text-2xl lg:text-4xl text-yellow-400">6747 1910</span></a> TO GET AN INSTANT QUOTE!    
            </div>
        </div>
      </div>
    </div>
    <!-- ///////////////////////////////////////// Ph section END ///////////////////////////////////////// -->
    <div class="w-full mt-6 mb-8 section">
      <div class="container px-4 pt-0 lg:pt-0 mx-auto flex flex-col lg:flex-row items-center justify-between">
          <div class="w-full lg:w-1/3 mx-auto">
            <div class="title-text">
              <div class="font-bold lg:font-extrabold text-2xl lg:text-3xl text-center lg:text-left leading-4">About E-Waste Recycling</div>
              <div class="font-bold text-3xl lg:text-5xl text-center lg:text-left leading-12">Need any</div> 
              <div class="font-bold text-3xl lg:text-5xl text-center lg:text-left leading-10">help?</div>
              <!-- <div class="font-bold text-5xl lg:text-5xl text-center lg:text-left leading-12"></div>  -->
              <div class="py-6 pr-none lg:pr-8 text-left lg:text-left text-gray-900 mt-2 lg:mt-12">
                Do you have old fashioned computers kept in your storage area? Most business establishments are now using computers to transact faster and more efficiently provide the needs of their clients and contact their business partners and other stakeholders in the most convenient way. Malfunctions of your computers can affect your ability to communicate. Getting rid of your old computers can be a very tough task. Not to worry, Atrex Services can help you with your e-waste disposal and recycling needs!
              </div>
            </div>
          </div>           
          <div class="w-full sm:w-full lg:w-1/3 mx-auto px-10 py-10 bg-gray-100">
            <div class="text-center text-gray-800 font-bold leading-none">
              <span class="text-2xl lg:text-3xl">Request a</span><br/><span class="text-4xl lg:text-5xl font-extrabold">Free Quote</span>
            </div>         
            <!-- feedback.activamedia.com.sg script begins here --><iframe allowTransparency="true" style="min-height:620px;height:inherit;overflow:auto;" width="100%" id="contactform123" name="contactform123" marginwidth="0" marginheight="0" frameborder="0" src="//feedback.activamedia.com.sg/my-contact-form-5979529.html"><p>Your browser does not support iframes. The contact form cannot be displayed. Please use another contact method (phone, fax etc)</p></iframe><!-- feedback.activamedia.com.sg script ends here -->
          </div>    
          <div class="w-full sm:w-full md:w-full lg:w-1/3 pl-0 lg:pl-8 mx-auto">
            <img src="images/man.png" width="100%" />
          </div>
      </div>
    </div>    
    <div class="bg-gray-300 section" id="testimonials">
      <div class="container">
        <div class="w-full text-center text-3xl md:text-5xl text-gray-800 font-bold leading-none mt-8 mb-12">
          Strong Partnership. Proven Track Record
        </div>
        <div class="w-full flex flex-wrap">
          <div class="w-1/2 md:w-1/2 lg:w-1/4 mb-8 pr-4 pl-4">
            <img src="/images/tp-logo.png">
          </div>
          <div class="w-1/2 md:w-1/2 lg:w-1/4 mb-8 pr-4 pl-4">
            <img src="/images/sp-logo.png">
          </div>
          <div class="w-1/2 md:w-1/2 lg:w-1/4 mb-8 pr-4 pl-4">
            <img src="/images/rp-logo.png">
          </div>
          <div class="w-1/2 md:w-1/2 lg:w-1/4 mb-8 pr-4 pl-4">
            <img src="/images/np-logo.png">
          </div>
          <div class="w-1/2 md:w-1/2 lg:w-1/4 mb-8 pr-4 pl-4">
            <img src="/images/ngee-ann-logo.png">
          </div>
          <div class="w-1/2 md:w-1/2 lg:w-1/4 mb-8 pr-4 pl-4">
            <img src="/images/nus-logo.png">
          </div>
          <div class="w-1/2 md:w-1/2 lg:w-1/4 mb-8 pr-4 pl-4">
            <img src="/images/ntu-logo.png">
          </div>
          <div class="w-1/2 md:w-1/2 lg:w-1/4 mb-8 pr-4 pl-4">
            <img src="/images/st-engineering-logo.png">
          </div>          
        </div>
        <!-- ///////////////////////////////////////// Ph section START ///////////////////////////////////////// -->
        <div class="max-w-none mb-6 bg-cover bg-middle bg-center bg-no-repeat">     
          <div class="container px-4 pt-6 mx-auto py-6 lg:content-center flex flex-wrap">
            <div class="w-full rounded-full py-2 lg:py-4 px-6 border-4 border-blue-200 bg-blue-800">        
                <div class="text-1xl text-center lg:text-3xl text-white font-bold">
                  CALL US AT <a href="tel:+6567471910"><span class="text-2xl lg:text-4xl text-yellow-400">6747 1910</span></a> TO GET AN INSTANT QUOTE!    
                </div>
            </div>
          </div>
        </div>
        <!-- ///////////////////////////////////////// Ph section END ///////////////////////////////////////// -->
      </div>
    </div>
    <div class="w-full about-bg lg:flex">
      <div class="w-full lg:w-12/12">
        <img class="xl:ml-auto w-full h-full" src="/images/about-img.jpg">
      </div>
      <div class="w-full lg:w-12/12 pt-12 pb-12 lg:pt-0 lg:pb-0 flex items-center justify-center">
        <div class="w-full xl:w-9/12 pl-3 pr-3 lg:pl-6 lg:pr-6 lg:m-auto xl:pl-3 py-6">
          <div class="w-full text-3xl md:text-5xl text-gray-800 font-bold leading-10 lg:leading-12 mb-12">
            <div class="text-2xl md:text-3xl">About Us</div>
            Atrex Services
          </div>
          <div class="text-lg text-gray-800 leading-snug">            
            <p>
              Established in 2003, our goal has always been to be our clients’ number one IT Solutions provider. We want to provide only the best of qualities and services, keeping them satisfied.
              <br/><br/>
              Over the years, we’ve managed to get different types of certifications necessary to show our clients that we are a trustworthy company that they can rely on.
              <br/><br/>
              We spent the last 15 years doing so and we are going to continue to doing so because We Make IT Happen.
              <br/><br/>
              Atrex Services has successfully completed the Awareness &amp; Internal Auditor Training on:
              ISO 9001:2015|ISO 14001:2015|ISO 45001:2018
            </p>            
          </div>
        </div>
      </div>      
    </div>
    <div class="w-full section-t">
      <div class="container px-4">
        <div class="w-full lg:flex lg:items-center lg:justify-center">          
          <div class="w-full lg:w-3/6 text-center">
            <img class="m-auto pb-6" src="/images/logo-painting.png">
            <!-- <div class="text-2xl md:text-3xl font-bold text-gray-800 leading-snug pb-10">
              Atrex Services Pte Ltd
            </div> -->
            <div class="text-base md:text-lg text-gray-800 leading-snug">
              <strong>Singapore Office (HQ)</strong><br/>
              52 Ubi Ave 3, Frontier #01-48<br/>
              <a href="tel:+6567471910">+65 67471910</a> / <a href="tel:+6594363876">94363876</a><br/>
              <a href="mailto:rinus@atrexservices.com">rinus@atrexservices.com</a><br/><br/>
              <strong>Malaysia Office</strong><br/>
              810 Kampung Chempaka, Jalan PJU 1/11, 47301 PJ, Malaysia<br/>
              <a href="tel:+60378807601">+603 7880 7601</a> / <a href="tel:+60378031309">+603 7803 1309</a><br/>
              <a href="mailto:rinus@atrexservices.com">rinus@atrexservices.com</a>
              <!-- 52 Ubi Ave 3, Frontier #01-48<br/>Singapore 408867<br/>
              Tel: <a href="tel:+6567471910">(+65) 6747 1910</a>  |  E-mail: <a href="mailto:Sales@AtrexServices.com">Sales@AtrexServices.com</a> -->
            </div>
          </div>
        </div>        
      </div>
    </div>
    <div class="w-full bg-white pt-5 pb-8 border-t-2 border-gray-300">
      <div class="container px-4 pt-6 text-center">
        <div class="w-full text-gray-800 text-sm">Website maintained by Activa Media. All right reserved.</div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.btn-wa {  
  background-color: #f2f2f2;
  border-radius: 100%;
  position: fixed;
  padding: 8px;
  bottom: 15px;
  right: 15px;
  z-index: 100;
}
</style>

<script>
import carousel from 'vue-owl-carousel'
import vueSmoothScroll from 'vue-smooth-scroll'
export default {
  components: {
    vueSmoothScroll,
    carousel
  }
}
</script>